import { useState } from "react";
import { IconButton } from "../../iconButton/IconButton";
import {
  copyButton,
  details,
  detailsSummary,
  errorStack
} from "./ErrorDetails.css";

interface ErrorDetailsProps {
  /**
   * The error instance to display
   */
  error: Error;
}

/**
 * Renders information about the error, ie. the stack trace.
 */
export function ErrorDetails({ error }: ErrorDetailsProps) {
  const [copied, setCopied] = useState(false);

  function handleCopy() {
    if (!error.stack) return;
    navigator.clipboard.writeText(error.stack).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <details className={details} open>
      <summary className={detailsSummary}>
        Error details (development only)
      </summary>
      <IconButton
        className={copyButton}
        iconName={copied ? "check" : "copy"}
        variant="tertiary"
        size="xs"
        onClick={handleCopy}
        aria-label={copied ? "Copied" : "Copy error details"}
      />
      <pre data-testid="error-stack" className={errorStack}>
        {error.stack}
      </pre>
    </details>
  );
}
